(function($) {

	'use strict';

	var init = function() {
        $('.hp-segments__nav__n1 .hp-segments__nav__item').on('click', openSegmentMenu);
        $('.hp-segments__back').on('click', backSegment);
    };

    var backSegment = function(e){
        var titleDOM = $('.hp-segments__title');
        
        $(this).addClass('disabled');
        $('.hp-segments__nav__n2.open, .hp-segments__nav__n2.open .hp-segments__nav__link.open').removeClass('open');
        titleDOM.addClass('transparent');

        window.setTimeout(function(){
            var titleContent = titleDOM.data('base');
            titleDOM.text(titleContent).removeClass('transparent');
            $('.hp-segments__nav .open').removeClass('open');
        }, 200);

        if(window.innerWidth < 992){
            $('.hp-segments__nav').height($('.hp-segments__nav__n1').height());
        }
    }
    
    var openSegmentMenu = function(e){
        e.stopPropagation();
        var n2 = $(e.currentTarget).children('.hp-segments__nav__n2');
        console.log(n2);
        if( n2.length ){
            var titleContent = $(e.currentTarget).children('.hp-segments__nav__link').attr('title');
        } else {
            var titleContent = false;
        }
        var titleDOM = $('.hp-segments__title');
        
        if(n2.length > 0){
            e.preventDefault();
        }

        //Fade-out title
        if(titleContent){
            titleDOM.addClass('transparent');
            $('.hp-segments__back').removeClass('disabled');
        }

        //Fade-out right all n1 items links with delay
        var n1Item = $('.hp-segments__nav__n1>.hp-segments__nav__item>a');
        n1Item.each(function(i){
            var count = n1Item.length,
                delayN1 = i*100,
                that = $(this);
            window.setTimeout(function(){
                that.addClass('open');
                if(count == i+1){
                    //Change and fade-in title
                    if(titleContent){
                        titleDOM.text(titleContent).removeClass('transparent');
                    }

                    //On tablet/mobile change container height
                    if(window.innerWidth < 992){
                        $('.hp-segments__nav').height(n2.height());
                    }

                    //Fade-in right select n2 items links after last n1 item's animation
                    n2.addClass('open');
                    n2.find('.hp-segments__nav__item>a').each(function(j){
                        var delayN2 = j*100,
                            that = $(this);
                        window.setTimeout(function(){
                            that.addClass('open').removeAttr("tabindex");;
                        }, delayN2);
                    });
                }
            }, delayN1);
        });
    }


	$(document).ready(function(){
        if($('body').hasClass('home')){
            init();
        }
	});

})(jQuery);
